export const config: any = {
  colorfulPrint: {
    color: '#FFF5DC',
    header: 'پرینت رنگی آنلاین و باکیفیت',
    desc: 'در سامانه چاپ آنلاین زیراکسی',
    why_ziraxi: {
      responsive_title: {
        title1: 'پرینت',
        title2: 'رنگی آنلاین',
      },
      background_alt:
        'پرینت تمام رنگی، پرینت رنگی انلاین و با کیفیت و مختص صفحاتی با بیشتر از 50 درصد تصاویر رنگی است',
      first_content: `<p class="mb-4 fw-bold">
            پرینت رنگی (تمام ‌رنگی) و اهمیت آن 
            </p>
            <p class="mb-5">
            پرینت رنگی از جمله خدمات خاص و ویژه در حوزه چاپ دیجیتال است. کتاب‌ها و جزوه‌هایی که دارای تصاویر رنگی هستند، حس خوب و لذت بخشی در خواننده ایجاد می‌کنند؛ همچنین به تجربه می‌توان گفت: عکس، نمودار و اشکال رنگی موجود در کتاب‌ها و مجلات، تأثیر زیادی بر روی یادگیری خوانندگان دارد؛ چراکه جزئیات موجود در تصاویر رنگی، باعث درک بهتر و بیشتر خواننده، از موضوع موردمطالعه می‌شود.<br />
            تأثیر مثبت تصاویر رنگی این خلاقیت را در عده‌ای ایجاد کرده که با چاپ رنگی عکس‌هایشان، خاطرات خود را ثبت کنند. یا حتی باعث شده است بیشتر شرکت‌ها و مؤسسات، برای چاپ تبلیغات خود (مانند بروشور، کاتالوگ، تراکت) پرینت رنگی را انتخاب کنند؛ چرا که تصاویر رنگی جذابیت بیشتری نسبت به تصاویر بی‌روح سیاه و سفید دارد.
            <br/>
            اما در چند سال گذشته هزینه پرینت رنگی  سر به فلک کشیده و این موضوع باعث ایجاد فشار اقتصادی به علاقه‌مندان این نوع پرینت شده است. بااین‌ حال هنوز هم عده زیادی به دنبال پرینت رنگی ارزان و باکیفیت هستند.
            </p>
            
            <p class="mb-4 fw-bold">
            بهترین مجموعه ارائه‌دهنده چاپ رنگی آنلاین و باکیفیت 
            </p>
            <p>
            با کمی جست‌و‌جو می‌توان مجموعه‌های زیادی را پیدا کرد که در زمینه چاپ پوستر، جزوه و غیره در حال فعالیت هستند و بعضی از این مجموعه‌ها به‌صورت آنلاین خدمات خود را ارائه می‌کنند. از بهترین مجموعه‌های <a href="/" >چاپ آنلاین</a> می‌توان به <span class="fw-bold">زیراکسی</span> اشاره کرد.
            </p>
            `,
      secound_content: `
            <p class="mb-5">
            این مجموعه همواره سعی دارد خدمات خود را در پایین‌ترین قیمت و بالا‌ترین کیفیت به مشتریان خود ارائه کند. با اینکه <a href="/price-list/full-color-print-price" >هزینه پرینت رنگی</a> در زیراکسی بسیار پایین‌تر از نرخ اتحادیه است؛ اما کیفیت خدمات این مجموعه در سطح بالایی قرار دارد و برای اعتماد هرچه بیشتر مشتریان، زیراکسی کلیه خدمات خود را تضمین کیفیت می‌کند.
            </p>
            <p class="mb-4 fw-bold">
            تضمین کیفیت در مجموعه چاپ آنلاین زیراکسی 
            </p>
            <p class="mb-5">
            فرقی نمی‌کند <a href="/black-and-white-print" >چاپ سیاه ‌و سفید</a> داشته باشید یا رنگی،
            زیراکسی کلیه خدمات خود را تضمین کیفیت می‌کند. چنانچه سفارشی کیفیت کافی نداشته باشد، بعد از اثبات این موضوع، زیراکسی موظف است مبلغ پرداختی توسط مشتری را به کیف پول و یا حسابش باز گرداند و یا سفارش مورد نظر را دوباره انجام دهد و به طور رایگان برای مشتری ارسال کند. این مجموعه، همواره در تلاش است رضایت مشتریان را جلب کند و خدمات خود را به بهترین شیوه ممکن ارائه کند.
            </p>
            `,
      line_content: 'در زیراکسی، پرینت رنگی آنلاین و باکیفیت تجربه کنید و از تصاویر رنگی خود لذت ببرید.',
      line_button: false,
      router_link: 'colorfulPrint',
      button_text: 'ثبت سفارش',
      background_src: 'colorful',
      background_postfix: '.webp',
      background_color: '#FFDCDC',
      third_content: `
            <p class="mb-4 fw-bold">
            پرینت رنگی آنلاین + ارسال رایگان
            </p>
            <p class="mb-5">
            علاقه کاربران برای داشتن ارسال رایگان، باعث شد شرکت زیراکسی راهکارهایی را برای ارسال سفارش‌ها به‌صورت رایگان ایجاد کند.<br />
            یکی از این راهکارها این است که سفارش کاربر بیشتر از 800 هزار توان باشد. چنانچه هزینه سفارشی از 800 هزار تومان بیشتر باشد، هزینه ارسال شما به طور خودکار رایگان می‌شود.<br />
            می‌توانید در صفحه <a href="/cheap-print">پرینت ارزان با ارسال رایگان</a> راهکارهای دیگری که باعث رایگان شدن ارسال شما می‌شود را مشاهده کنید.
            </p>
            <p class="mb-4 fw-bold">دلایل کاهش هزینه پرینت رنگی در زیراکسی</p>
            <p>
            پایین بودن هزینه‌ها در زیراکسی دلایل متعددی دارد. این مجموعه با توجه به داشتن تأمین‌کنندگان بزرگ مواد اولیه و تیراژ بالای چاپ، توانسته است مواد اولیه خود (مانند کاغذهای اورجینال، تونرهای رنگی و...) را به‌صورت عمده و قیمت بسیار پایین‌تر خریداری کند.
            <br/>
            همچنین زیراکسی با استفاده از دستگاه‌های صنعتی چاپ دیجیتال و به‌روز دنیا سرعت انجام سفارش‌ها را افزایش و هزینه تعمیر و نگهداری دستگاه‌ها را کاهش داده است.
            <br/>
            مجموع این عوامل، باعث شده هزینه تمام شده برای مشتری به حداقل مقدار ممکن برسد؛ به‌گونه‌ای که تعرفه پرینت تمام ‌رنگی زیراکسی یک پنجم و هزینه پرینت نیمه ‌رنگی یک هفتم نرخ اتحادیه فتوکپی و تکثیر است. درضمن، با افزایش تعداد برگ سفارش‌ها، هزینه‌ها در زیراکسی به‌صورت پلاکانی کاهش بیشتری پیدا می‌کند.
            <br/>
            برای دیدن تخفیفات پلکانی پرینت رنگی در زیراکسی بر روی <a href="/price-list/full-color-print-price" > تعرفه پرینت رنگی </a> کلیک کنید.<br />
            <a href="/half-color-print" > چاپ رنگی ارزان </a>، آنلاین و باکیفیت را در سامانه چاپ آنلاین زیراکسی تجربه کنید
            </p>
            `,
    },
    questions: [
      {
        question: 'پرینت تمام ‌رنگی چیست و چه کاربردی دارد؟',
        answer: `
        <p>
        یکی از خدمات پرطرف‌دار زیراکسی، پرینت تمام‌ رنگی است. این مجموعه پرینت رنگی را در دو بخش تمام ‌رنگی و نیمه ‌رنگی به مشتریان خود ارائه می‌کند. پرینت تمام‌ رنگی برای صفحاتی است که بیشتر از 50 درصد تصاویر رنگی دارند. این نوع چاپ کاربرد فراوانی دارد که از جمله این کاربردها می‌توان به موارد زیر اشاره کرد.
        </p>
        <ul>
        <li>چاپ رنگی تراکت، کاتالوگ بروشور و غیره</li>
        <li>چاپ رنگی پوستر و تصاویر</li>
        <li>چاپ رنگی مجله</li>
        <li>چاپ رنگی کتاب‌ها و جزوه‌هایی که بیشتر صفحات آن‌ها را تصاویر تشکیل داده است</li>
        </ul>
        `,
        id: '1',
      },
      {
        question: 'راهکار زیراکسی برای کاهش بیشتر هزینه پرینت رنگی چیست؟',
        answer: `
        <p>از دیگر خدمات زیراکسی می‌توان به <a href="/half-color-print" > پرینت نیمه ‌رنگی </a>  اشاره کرد. این نوع پرینت مخصوص صفحاتی است که کمتر از 50 درصد آن رنگی است و هزینه کمتری نسبت به پرینت تمام‌ رنگی دارد.
این مجموعه همچنین برای اولین‌بار در کشور <a href="/combined-printing" > پرینت ترکیبی </a> را ارائه کرده است که در آن کاربران می‌توانند برخی از صفحات فایل مورد نظرشان را به‌صورت رنگی و برخی دیگر را به‌صورت سیاه و سفید پرینت کنند و ترکیبی از پرینت رنگی و سیاه و سفید داشته باشند.
</p>`,
        id: '2',
      },
    ],
  },
  blackAndWhitePrint: {
    color: '#FFDCDC',
    header: 'پرینت سیاه و سفید ارزان',
    desc: 'در سامانه چاپ آنلاین زیراکسی',
    why_ziraxi: {
      responsive_title: {
        title1: 'پرینت',
        title2: 'سیاه و سفید ارزان',
      },
      background_alt:
        'پرینت سیاه و سفید ارزان و باکیفیت در سامانه چاپ آنلاین زیراکسی',
      background_src: 'black-white',
      background_postfix: '.webp',
      background_color: '#DDDCFF',
      first_content: `<p class="mb-4 fw-bold">
                پرینت سیاه‌ و سفید 
                </p>
                <p class="mb-5">
پرینت سیاه ‌و سفید یکی از محبوب‌ترین خدمات چاپ است و به دلیل پایین‌بودن قیمت آن طرفداران زیادی دارد. از جمله طرفداران چاپ سیاه ‌و سفید، می‌توان به دانش‌آموزان و دانشجویانی اشاره کرد که در دوران تحصیل خود کتاب‌ها و جزوه‌های زیادی را پرینت و مطالعه می‌کنند.
<br/>
اما در چند سال گذشته، با توجه به افزایش قیمت کاغذ و مواد مصرفی چاپ، این گونه خدمات افزایش قیمت چشمگیری داشته‌اند و به همین دلیل پیداکردن مرکزی که بتواند، پرینت سیاه ‌و سفید ارزان و باکیفیتی ارائه کند کمی دشوار است.
</p>

<p class="mb-4 fw-bold">
مجموعه‌ای که چاپ سیاه‌ و سفید ارزان و باکیفیت ارائه می‌دهد
</p>
<p>
یکی از مجموعه‌هایی که به طور گسترده در زمینه چاپ سیاه ‌و سفید جزوه و کتاب فعالیت می‌کند، <span class="fw-bold">زیراکسی</span> است.
<br/>
 این مجموعه در راستا ارائه <a href="/cheap-print" > چاپ ارزان </a> و باکیفیت، پلتفرمی منحصربه‌فرد و کاربردی ایجاد کرده تا کاربران بتوانند در سراسر کشور، جزوات، کتاب‌ها و اسناد خود را به‌صورت آنلاین پرینت کنند.
 <br/>
این پلتفرم، بسیار ساده و کاربردی است؛ به‌گونه‌ای که کاربران می‌توانند در آن به‌راحتی ثبت سفارش کنند و جزئیات سفارش خود را به طور دقیق در پنل سفارش‌گیری وارد نمایند.
                </p>
                
                `,
      secound_content: `
                <p class="mb-4 fw-bold">
                خدماتی که زیراکسی ارائه می‌دهد 
                </p>
                <p class="mb-5">
                از جمله خدماتی که زیراکسی به کاربران خود ارائه می‌کند، می‌توان به پرینت سیاه‌ و سفید، <a href="/full-color-print" > پرینت تمام‌ رنگی </a>، <a href="/half-color-print" > پرینت نیمه ‌رنگی </a> و <a href="/combined-printing" > پرینت ترکیبی </a> اشاره‌کرد.<br />
این مجموعه به‌تازگی خدماتی همچون ویرایش، <a href="/thesis-binding" > پرینت و صحافی پایان‌ نامه </a> را نیز به دانشجویان ارائه کرده که با استقبال بی‌نظیر آن‌ها روبه‌رو شده است. خدمات دیگری از جمله چاپ کتاب، چاپ مجله و غیره در این مجموعه ارائه می‌شود که در روزهای آینده به خدمات موجود در وب‌سایت زیراکسی اضافه خواهد شد.   
                </p>
                <p class="mb-4 fw-bold">
                کاهش 90 درصدی قیمت پرینت سیاه ‌و سفید در زیراکسی 
                </p>
                <p class="mb-5">
                اگر نگاهی به تعرفه‌های خدمات پرینت زیراکسی بیندازید، متوجه می‌شوید که <a href="/price-list/black-and-white-print-price" > قیمت پرینت سیاه ‌و سفید </a> این مجموعه یک دهم تعرفه اتحادیه کپی و پرینت است. زیراکسی، همواره در تلاش است که تمامی خدمات خود را در پایین‌ترین قیمت و بالاترین کیفیت به مشتریان خود ارائه کند.<br />
مجموعه <a href="/" > چاپ آنلاین </a> زیراکسی برای رضایت هرچه بیشتر مشتریان، کلیه خدمات خود را تضمین کیفیت می‌کند و در صورت پایین‌بودن کیفیت چاپ، هزینه پرداخت شده را به کیف پول و یا حساب مشتری باز می‌گرداند و یا سفارش را به طور رایگان باز ارسال می‌کند.
                </p>
                `,
      line_content: `
                
                با زیراکسی پرینت سیاه و سفید ارزان و با کیفت را تجربه کنید
    
                
                `,
      button_text: 'ثبت سفارش',
      line_button: false,
      router_link: 'black-and-white-print',
      third_content: `
                <p class="mb-4 fw-bold">
                راز موفقیت زیراکسی در کاهش قیمت پرینت سیاه‌ و سفید
                              </p>
              <p class="mb-5">
              کاهش قیمت چاپ سیاه ‌و سفید در این مجموعه به دلیل کاهش هزینه‌های مصرفی آن است.<br />
              از آن‌جایی که زیراکسی پرینت جزوه و کتاب را به‌صورت روزانه و در حجم زیاد انجام می‌دهد، مواد اولیه خود را به‌صورت عمده و بدون واسطه خریداری می‌کند و با این کار هزینه‌های خود را به‌شدت کاهش می‌دهد.<br />
              زیراکسی همچنین با استفاده‌کردن از دستگاه‌های به‌روز و پیشرفته چاپ دیجیتال هزینه تعمیرات و نگهداری آن‌ها را به حداقل مقدار ممکن می‌رساند. همه این عوامل باعث کاهش قیمت پرینت سیاه‌ و سفید در این مجموعه می‌شود.
              </p>
                <p class="mb-4 fw-bold">
                بیشترین کاربرد پرینت سیاه ‌و سفید 
                </p>
              <p >
              پرینت سیاه‌ و سفید هم در مدارس و دانشگاه‌ها و هم در شرکت‌ها و مؤسسات کاربرد فراوانی دارد. بیشترین کاربرد این نوع پرینت می‌توان به موارد زیر اشاره کرد.
              </p>
              <ul class="mb-5 me-5">
          <li>
          چاپ جزوه و کتاب 
          </li>
          <li>
          پرینت پایان‌ نامه و مقاله
          </li>
          <li>
          چاپ دفتر برنامه‌ریزی کنکور
          </li>
          <li>
          چاپ دفتر برنامه‌ریزی روزانه
          </li>
          <li>
          چاپ تراکت
          </li>
          <li>
          چاپ دفتر اختصاصی
          </li>
          </ul>
          <p class="mb-4 fw-bold">
          پرینت سیاه ‌و سفید + ارسال رایگان 
          </p>
        <p class="mb-5">
        با توجه به هزینه بالای پست، کاربران تمایل دارند، همواره سفارش‌هایی که دارند به‌صورت رایگان انجام شود.
        زیراکسی با درک نیاز مشتریان و برای جلب رضایت آن‌ها، راهکارهایی را برای رایگان شدن ارسال، در نظر گرفته است. از جمله این راهکارها می‌توان به ثبت سفارش بالای 800 هزار تومان اشاره کرد.
        <br/>
        راهکار‌های دیگری نیز وجود دارد که می‌توانید در صفحه<a href="/cheap-print" > پرینت ارزان با ارسال رایگان </a> مشاهده کنید.</p>
                `,
    },
    questions: [
      {
        question:
          ' آیا می‌توانم سفارش خود را لغو یا تغییر دهم؟',
        answer: `
        بله، شما می‌توانید سفارش خود را لغو یا تغییر دهید تا زمانی که آن را پرداخت نکرده باشید. برای این کار باید به صفحه سفارشات خود بروید و روی دکمه لغو یا تغییر کلیک کنید. اگر سفارش خود را پرداخت کرده باشید، متاسفانه امکان لغو یا تغییر آن وجود ندارد.
        `,
        id: '1',
      },
      {
        question:
          ' چگونه می‌توانم سفارش پرینت سیاه و سفید بدهم؟',
        answer: `
        برای سفارش پرینت سیاه و سفید، ابتدا باید فایل خود را به صورت PDF آپلود کنید. سپس تعداد صفحات، جنس کاغذ، رنگ یا سیاه و سفید بودن و سایر گزینه‌های مورد نظر خود را انتخاب کنید. در نهایت می‌توانید آدرس تحویل و روش پرداخت خود را مشخص کنید.
        `,
        id: '2',
      },
      {
        question:
          ' چه مدت زمان لازم است تا سفارش من آماده شود؟',
        answer: `
        زمان آماده شدن سفارش بستگی به حجم و نوع سفارش شما دارد. ما سعی می‌کنیم تا سفارشات را در کمترین زمان ممکن انجام دهیم. معمولاً سفارشات در همان روز یا روز بعد آماده می‌شوند. برای اطلاع از وضعیت سفارش خود می‌توانید به بخش سفارشات من مراجعه کنید
        `,
        id: '3',
      },
      {
        question:
          'آیا می‌توان صفحات خاصی از فایل آپلود شده را به‌صورت سیاه ‌و سفید پرینت کرد؟',
        answer: `
            بله در پنل سفارش گیری زیراکسی این امکان وجود دارد. کافیست مجموع صفحاتی که میخواهید پرینت کنید را در بخش تعداد صفحات وارد کنید و در بخش توضیحات بیشتر،شماره صفحات و یا بازه صفحاتی که میخواهید پرینت کنید را وارد کنید.
        `,
        id: '4',
      },
      {
        question:
          'چرا باید برای گرفتن پرینت کتاب‌ها و جزوات خود زیراکسی را انتخاب کنیم؟',
        answer: `
        <ul>
        <li>ارزان و به‌صرفه‌بودن</li>
        <li>بالابودن کیفیت پرینت</li>
        <li>صحافی عالی و بی‌نقص</li>
        <li>تضمین کیفیت</li>
        <li>داشتن پلتفرمی ساده و راحت برای انجام سفارش</li>
        </ul>        `,
        id: '5',
      },
    ],
  },
  halfColorPrint: {
    color: '#FFDCDC',
    header: 'پرینت نیمه رنگی',
    desc: 'مختص صفحات رنگی با پس زمینه سفید',
    why_ziraxi: {
      responsive_title: {
        title1: 'پرینت',
        title2: 'نیمه رنگی',
      },
      background_alt:
        'پرینت نیمه‌ رنگی، پرینت رنگی ارزان و باکیفیت و مختص صفحاتی با کمتر از 50 درصد تصایر رنگی است',
      background_src: 'half-color',
      background_postfix: '.webp',
      background_color: '#FFF5DC',
      first_content: `<p class="mb-4 fw-bold">
              پرینت رنگی ارزان و اهمیت آن 
              </p>
              <p class="mb-5">
              پرینت رنگی ارزان و باکیفیت، از جمله خدماتی است که دانش‌آموزان و دانشجویان زیادی به دنبال آن هستند.
به تجربه می‌توان گفت خواندن کتاب‌ها و جزواتی که تصاویر و متن‌های رنگی دارند بسیار لذت‌بخش‌تر از خواندن کتاب‌ها و جزواتی است که صفحات آن‌ها به طور کامل سیاه و سفید هستند.<br />
اما کمتر مجموعه‌ای پیدا می‌شود که بین چاپ صفحات تمام‌ رنگ مانند پوستر و صفحاتی که تنها بخشی از آن رنگی است (مانند جزوه‌ای که دارای نمودار‌های رنگی با متن سیاه‌ و سفید است) تفاوت قائل شود. حتی اتحادیه تکثیر و کپی هم تنها یک قیمت برای کپی رنگی تعیین کرده است.<br />
از طرفی نرخ چاپ رنگی آن‌قدر زیاد است که می‌تواند فشار اقتصادی زیادی را برای علاقه‌مندان به این نوع پرینت ایجاد کند. مراکز چاپ زیادی در تلاش هستند که چاپ رنگی ارزان و باکیفیتی را به مشتریان خود ارائه کنند. اما بیشتر آن‌ها این کار را با استفاده کردن از مواد نا‌مرغوب انجام می‌دهند که این کار باعث نارضایتی مشتریان در بلندمدت می‌شود.
              </p>
              <p class="mb-4 fw-bold">
              معتبر‌ترین مجموعه چاپ آنلاین در ارائه پرینت رنگی ارزان و باکیفیت 
              </p>
              <p class="mb-5">
              از جمله مراکزی که توانسته است چاپ رنگی ارزان و با کیفیتی به مخاطبان خود ارائه دهد و کاربران زیادی را به سمت خود جذب کند، مجموعه چاپ آنلاین <span class="fw-bold">زیراکسی</span> است.<br />
              این مجموعه بزرگ، از بهترین مواد چاپ موجود در بازار استفاده می‌کند و با توجه به سابقه چندین ساله‌ای که در زمینه چاپ و پرینت دارد، توانسته با روش‌های مختلف هزینه‌های ناشی از این‌گونه خدمات را برای مشتریان خود کاهش دهد.<br />
              از جمله این روش‌ها می‌توان به این موضوع اشاره کرد که زیراکسی پرینت رنگی را به دو صورت تمام‌ رنگی و نیمه‌ رنگی به مخاطبان خود ارائه کرده است.
              </p>
              <p class="mb-4 fw-bold">
              پرینت نیمه‌ رنگی چیست؟ چه تفاوتی با پرینت تمام ‌رنگی دارد؟
              </p>
              <p>
              در مجموعه زیراکسی، پرینت نیمه‌ رنگی برای صفحاتی ارائه شده که کمتر از 50 درصد آن‌ها را تصاویر رنگی تشکیل می‌دهد. مانند کتاب‌ها و جزواتی که دارای تصاویر و نمودارهای کوچک رنگی هستند و پس‌زمینه آن‌ها سفید است.
              </p>
              
              `,
      secound_content: `
              <p class="mb-5">
              از آن‌جایی که جزوه‌های معلمین و اساتید معمولاً چنین ویژگی دارد، <a href="/booklet-print" > چاپ جزوه </a> آن‌ها با این روش انجام می‌شود. اما پرینت تمام‌ رنگی برای صفحاتی ارائه شده است که بیشتر از 50 درصد آن‌ها را تصاویر رنگی تشکیل می‌دهد؛ مانند پوستر‌ها و یا تصاویر بزرگی که در صفحات مجلات چاپ می‌شود.
              </p>
              <p class="mb-4 fw-bold">
              تفاوت هزینه پرینت رنگی در زیراکسی و نرخ اتحادیه پرینت
              </p>
              <p class="mb-5">
              در حالت کلی هزینه خدمات ارائه شده در زیراکسی، بسیار پایین‌تر از تعرفه اتحادیه است، به طوری که در این مجموعه قیمت پرینت تمام‌ رنگی یک پنجم و قیمت پرینت نیمه‌ رنگی یک هفتم نرخ اتحادیه کپی است. شما می‌توانید در صفحه <a href="/price-list/full-color-print-price" >قیمت پرینت رنگی </a>، هزینه‌های پرینت رنگی و نیمه رنگی در زیراکسی را مشاهده کنید.
              </p>
              <p class="mb-4 fw-bold">
              پرینت رنگی ارزان + تضمین کیفیت
              </p>
              <p class="mb-5">
              کلیه خدمات در مجموعه زیراکسی تضمین کیفیت دارد. این موضوع بدین معناست که اگر سفارش شما کیفیت مطلوبی نداشته باشد، پس از اثبات این موضوع، وجه پرداختی توسط مشتری به کیف پول و یا حساب مشتری عودت داده می‌شود و یا سفارش مشتری پس از پرینت دوباره به طور رایگان باز ارسال می‌شود.
              <br/>
              همچنین این مجموعه در کلیه مراحل انجام سفارش‌ها، بخش کنترل کیفی دارد تا کلیه سفارش‌ها در بهترین حالت ممکن انجام شود و بدون هیچ عیب و نقصی به دست مشتریان برسد.
              </p>              
              `,
      line_content: 'در سامانه چاپ آنلاین زیراکسی، پرینت رنگی ارزان و باکیفیت را تجربه کنید.',
      button_text: 'ثبت سفارش',
      line_button: false,
      router_link: 'halfColorPrint',
      third_content: `
              <p  class="mb-4 fw-bold">
              دلیل پایین‌بودن هزینه‌ها در زیراکسی 
              </p>
              <p class="mb-5">
              کاهش هزینه‌ها در زیراکسی به دلیل ثبت سفارش بالا‌ی روزانه است.
این موضوع باعث می‌شود این مجموعه مواد اولیه خود (مانند کاغذ، تونر و غیره) را به طور عمده تهیه کند و دست واسطه را از میان بردارد و هزینه‌های خود را به‌شدت کاهش دهد.<br />
همچنین زیراکسی با تکیه بر نیروهای متخصص و دستگاه‌های به روزی که دارد سرعت کار خود را بالا برده و هزینه‌های ناشی از تعمیرات و نگهداری را پایین آورده است. مجموعه این عوامل باعث می‌شود زیراکسی بتواند پرینت رنگی ارزان و با کیفتی را بتواند ارائه کند.
              </p>
              `,
    },
    questions: [
      {
        question: ' پرینت نیمه ‌رنگی چه کاربردی دارد؟',
        answer: 'پرینت نیمه رنگی برای سفارشاتی طراحی شده که تصاویر رنگی صفحات آن، کمتر از 50 درصد باشد؛ به طور مثال پرینت رنگی جزواتی که دارای متن رنگی با پس‌زمینه سفید و یا دارای نمودار و تصاویر کوچک رنگی با پس‌زمینه سفید هستند.',
        id: '1',
      },
      {
        question: 'آیا پرینت نیمه ‌رنگی به معنای پرینت رنگی باکیفیت کمتر است؟',
        answer: 'خیر. به هیچ وجه این‌طور نیست. صفحاتی که کمتر از 50 درصد تصویر رنگی دارند، مواد رنگی کمتری مصرف می‌کنند؛ در نتیجه باید هزینه کمتری نسبت به پرینت تمام‌ رنگی داشته باشد. این موضوعی است که هر مجموعه‌ای باید به آن توجه کند که متأسفانه این‌گونه نیست.',
        id: '2',
      },
      {
        question: 'آیا زیراکسی به معلمین و مدارس که دارای جزوه و کتاب‌های متعدد هستند تخفیف بیشتری می‌دهد؟',
        answer: 'بله. زیراکسی همواره آماده خدمت‌رسانی و عقد قرارداد با معلم‌ها و مدارس است و با توجه به تعداد سفارش‌ها تخفیف‌های ویژه‌ای را به آن‌ها ارائه می‌کند.',
        id: '3',
      },
      {
        question: 'زیراکسی چه خدماتی ارائه می‌دهد؟',
        answer: "به جز پرینت رنگی (که شامل نیمه رنگی و تمام رنگی می‌شود)، زیراکسی <a href='/black-and-white-print'> پرینت سیاه ‌و سفید </a> و <a href='/combined-printing'> پرینت ترکیبی </a> را نیز به کاربران خود ارائه کرده است. همچنین این مجموعه به دانشجویان خدمات صحافی و <a href='/thesis-editing'>ویرایش پایان ‌نامه</a> را نیز ارائه کرده که با استقبال بی‌نظیری روبه‌رو شده است. علاوه بر موارد گفته شده، این مجموعه در زمینه چاپ کتاب، پوستر و مجله نیز فعالیت می‌کند که به‌زودی به خدمات زیراکسی اضافه خواهد شد.",
        id: '4',
      },
    ],
  },
  mixedPrint: {
    color: '#DCF7FF',
    header: 'پرینت ترکیبی',
    desc: 'ترکیبی از پرینت رنگی و سیاه و سفید',
    why_ziraxi: {
      responsive_title: {
        title1: 'پرینت',
        title2: 'ترکیبی',
      },
      background_alt: 'پرینت ترکیبی، ترکیبی از پرینت سیاه و سفید و رنگی است ',
      background_src: 'mixed',
      background_postfix: '.webp',
      background_color: '#F2DCFF',
      first_content: `<p class="mb-4 fw-bold">
                پرینت ترکیبی 
                </p>
                <p class="mb-4">
                بخش زیادی از یک کتاب و یا جزوه، معمولاً دارای صفحاتی با متن سیاه‌ و سفید و بخشی از آن را صفحاتی با تصاویر رنگی تشکیل می‌دهد.
                <br/>
                اگر بخواهید کل صفحات را به صورت سیاه‌ و سفید پرینت کنید، جذابیت تصاویر از بین می‌رود و اگر بخواهید پرینت رنگی داشته باشید، هزینه زیادی باید پرداخت کنید. بهترین کار این است که صفحات دارای متن را به‌صورت سیاه ‌و سفید و صفحات دارای تصویر را به‌صورت رنگی پرینت کنید. به عبارت دیگر، ترکیبی از هر دو را داشته باشید.
                </p>
                
                <p class="mb-4 fw-bold">
                پرینت ترکیبی برای اولین‌بار در کشور 
                </p>
                <p>
                در گذشته برای گرفتن پرینت ترکیبی باید به‌صورت حضوری به یکی از مراکز ارائه‌دهنده خدمات چاپ مراجعه و بعد از کلی اتلاف وقت و انرژی و هزینه، سفارش خود را دریافت می‌کردید؛ چراکه در مجموعه‌هایی که خدمات پرینت اینترنتی ارائه می‌دادند، امکان گرفتن پرینت ترکیبی وجود نداشت.
                <br/>
                یکی از مجموعه‌هایی که خدمات <a href="/online-print">پرینت آنلاین</a> ارائه می‌دهد و همواره برای جلب رضایت مشتریان تلاش می‌کند، مجموعه چاپ آنلاین زیراکسی است.
                <br/>
                مهم‌ترین ویژگی‌های این مجموعه ارائه خدماتی متمایز و کاربردی است که به‌خوبی بتواند نیاز کاربران را برطرف کند. زیراکسی برای اولین‌بار در کشور پرینت ترکیبی را به خدمات خود اضافه کرده است تا کاربران بتوانند ترکیبی از پرینت سیاه ‌و سفید و پرینت رنگی را تجربه کنند.
                </p>
                `,
      secound_content: `
                <p class="mb-4">
                در بخش پرینت ترکیبی، کاربران می‌توانند برای <a href="/booklet-print">چاپ جزوه </a> و یا کتاب‌های خود شماره صفحات و یا بازه‌ای از صفحاتی که تمایل دارند به‌صورت تمام‌ رنگی و یا نیمه‌ رنگی پرینت شوند را مشخص کنند و ترکیبی از پرینت سیاه ‌و سفید و رنگی داشته باشند.<br />
                در زیراکسی به‌آسانی و مطابق سلیقه‌تان پرینت کنید
                </p>
              `,
      third_content: `
              <p class="mb-4 fw-bold mt-3 pt-5">
              کاربردی‌ترین سامانه ثبت سفارش چاپ آنلاین
              </p>
              <p class="mb-4">
              از دیگر ویژگی‌های مهم زیراکسی داشتن سایتی کاربردی و کاربرپسند است. تمام دغدغه تیم فنی زیراکسی آن است که کاربران به‌سادگی سفارش خود را ثبت کنند و تجربه‌ای دلچسب از ثبت سفارش، در این مجموعه داشته باشند.
              </p>
              <p class="mb-4 fw-bold pt-5">
              قیمت پرینت ترکیبی 
              </p>
              <p class="mb-5">
              قیمت پرینت ترکیبی به تعداد صفحات سیاه ‌و سفید و رنگی صفحات سفارش شما بستگی دارد.<br />
              همچنین با توجه به تعداد برگ سفارش شما هزینه‌ها به‌صورت پلکانی کاهش می‌یابد. برای دیدن تعرفه و تخفیف پلکانی پرینت سیاه و سفید بر روی <a href="/price-list/black-and-white-print-price">هزینه پرینت سیاه ‌و سفید</a> و برای دیدن تعرفه و تخفیف پلکانی پرینت رنگی بر روی <a href="/full-color-print-price">هزینه پرینت رنگی</a> کلیک کنید.
              </p>
              `,
      line_content: 'در زیراکسی به‌آسانی و مطابق سلیقه‌تان پرینت کنید',
      button_text: 'ثبت سفارش',
      line_button: false,
      router_link: 'mixedPrint',
    },
    questions: [
      {
        question: 'زیراکسی چگونه هزینه‌های خود را کاهش می‌دهد و خدمات خود را باکیفیت بالایی ارائه می‌دهد؟',
        answer: 'کاهش هزینه‌ها در زیراکسی دلایل متعددی دارد. از مهم‌ترین آن‌ها می‌توان به داشتن نیروهای متخصص و دستگاه‌های چاپ به‌روز دنیا اشاره کرد که باعث کاهش هزینه‌های تعمیر و نگهداری شده است. همچنین زیراکسی با خرید عمده مواد مصرفی و ارتباط با تأمین‌کنندگان بزرگ توانسته است مواد اولیه خود را با قیمت بسیار پایین تهیه کند. مجموع این عوامل باعث کاهش هزینه‌ها در این مجموعه و در نتیجه کاهش هزینه‌های مشتری شده است. ناگفته نماند که مواد مصرفی در زیراکسی از بهترین مواد موجود در بازار است و کاهش هزینه‌ها در این مجموعه نشانه کاهش کیفیت نیست.',
        id: '3'
      },
      {
        question: 'آیا در صورت نارضایتی مشتری از کیفیت پرینت، امکان باز ارسال و یا عودت وجه وجود دارد؟',
        answer: 'بله قطعاً. زیراکسی تمام خدمات خود را تضمین کیفیت کرده است و درصورتی‌که کیفیت سفارش شما پایین باشد بعد از اثبات این موضوع، به‌سرعت سفارش شما باز ارسال خواهد شد و یا در صورت تمایل مشتری هزینه پرداخت شده به کیف پول و یا حساب مشتری بازمی‌گردد. ',
        id: '1',
      },
      {
        question: 'با گرفتن پرینت ترکیبی چند درصد در هزینه‌ها صرفه‌جویی می‌شود؟',
        answer: 'با توجه به اینکه قیمت پرینت سیاه ‌و سفید یک دهم نرخ اتحادیه تکثیر و هزینه پرینت رنگی در زیراکسی یک هفتم قیمت اتحادیه است، شما می‌توانید هزینه‌های ناشی از پرینت را به‌شدت کاهش دهید. با توجه به تعداد صفحات سیاه ‌و سفید و صفحات رنگی این کاهش هزینه برای هر سفارش متفاوت است.',
        id: '2',
      },
    ],
  },
  onlinePrint: {
    color: '#DCEBFF',
    header: 'سامانه چاپ آنلاین زیراکسی ',
    desc: 'ساده‌ترین پلتفرم پرینت آنلاین',
    why_ziraxi: {
      responsive_title: {
        title1: 'پرینت',
        title2: 'ترکیبی',
      },
      background_alt: 'پرینت ترکیبی، ترکیبی از پرینت سیاه و سفید و رنگی است ',
      background_src: 'online-print',
      background_postfix: '.webp',
      background_color: '#EFFFDC',
      first_content: `<p class="mb-4 fw-bold">
                  پرینت آنلاین    
                </p>
                <p class="mb-5">
               در دنیایی که شاهد تغییرات گسترده در حوزه دیجیتال است، از جمله خدماتی که کاربران زیادی را به خود جلب کرده، پرینت آنلاین است.<br />
درگذشته نه‌چندان دور، برای گرفتن پرینت و کپی باید زمان زیادی را در پشت ترافیک و صف‌های طولانی تلف می‌کردیم. اما امروزه با پیشرفت تکنولوژی عملیات خدمات چاپ بسیار سریع‌تر، آسان‌تر و به‌صورت آنلاین انجام می‌شود. سایت‌های پرینت آنلاین زیادی وجود دارند که کاربران می‌توانند از خدمات آن‌ها استفاده کنند.
</p>
                <p class="mb-4 fw-bold">
                  معتبر‌ترین مرکز پرینت آنلاین
                </p>
                <p>
یکی از بهترین سایت‌های چاپ که به‌صورت آنلاین فعالیت می‌کند، <span class="fw-bold">زیراکسی</span> است. <br />
این مجموعه همواره تلاش می‌کند تا خدماتی متنوع با قیمت‌هایی مناسب به کاربران خود ارائه دهد. از جمله خدمات این مجموعه، می‌توان به <a href="/black-and-white-print">چاپ سیاه و سفید </a>، <a href="/full-color-print">چاپ رنگی </a> ،  ویرایش، <a href="/thesis-binding">پرینت و صحافی پایان‌نامه </a>  اشاره کرد که به دلیل بالا بودن کیفیت، مورد توجه کاربران زیادی قرار گرفته است.
                </p>
                `,
      secound_content: `
         <p class="mb-4 fw-bold">
خدمات منحصر به فرد زیراکسی    
                </p>
                <p class="mb-5">
                یکی از خصوصیات مهم زیراکسی که توجه کاربران زیادی را به خود جلب کرده، فرایند خرید آسان و سایت کاربرپسند آن است. در زیراکسی کاربران می‌توانند در کم‌ترین بازه زمانی ممکن، فایل مورد نظر خود را آپلود و پس از وارد کردن مشخصات پرینت ثبت سفارش نمایند.<br />
در این پنل، کاربران جزئیات دقیق و کامل پرینت فایل خود را وارد می‌کنند تا سفارش، متناسب با نظر و سلیقه آن‌ها انجام شود. همچنین اگر کاربران تمایلی به ثبت سفارش از طریق سایت را نداشته باشند، می‌توانند از طریق شبکه‌های اجتماعی مختلف ثبت سفارش خود را انجام دهند.<br />
یکی دیگر از ویژگی‌های مهم زیراکسی، ارائه خدماتی متنوع و متناسب با نیاز مشتریان است. از جمله این خدمات می‌توان به <a href="/combined-printing"> پرینت ترکیبی </a> اشاره کرد.<br />
زیراکسی برای اولین‌بار در کشور پرینت ترکیبی را به خدمات خود اضافه کرده است تا کاربران هنگام پرینت آنلاین جزوه و یا کتاب‌های خود، بتوانند صفحاتی که تنها دارای متن است به‌صورت سیاه و سفید و صفحاتی که دارای تصویر هستند را به‌صورت رنگی و یا نیمه رنگی پرینت کنند.<br />
با زیراکسی <a href="/online-print"> چاپ آنلاین </a> و با کیفیت داشته باشید و در زمان و انرژی خود صرفه‌جویی کنید.
                </p>
           
              `,
      third_content: `
              <p  class="mb-4 fw-bold mt-5 pt-5">
                با پشتیبانی متعهد زیراکسی، با خیال راحت پرینت آنلاین داشته باشید
              </p>
              <p class="mb-4">
این که در حین سفارش و یا حتی بعد از آن، دچار مشکل شوید و یا سوالی برای شما ایجاد شود امری طبیعی است.
یکی از ویژگی‌هایی که ارائه‌دهندگان خدمات پرینت آنلاین را از یکدیگر متمایز می‌کند، نوع برخورد آن‌ها با مشکل و یا سؤال کاربران است. <br />
زیراکسی با تیم پشتیبانی متعهد و متخصصی که دارد، پشتیبانی کاملی را به مشتریان خود عرضه می‌کند و به‌صورت شبانه‌روزی و در هفت روز هفته آماده پاسخگویی به مشتریان خود است. این تیم تمام تلاش خود را به کار گرفته تا کاربران تجربه‌ای عالی از ثبت سفارش آنلاین پرینت داشته باشند.               </p>
              <p  class="mb-4 fw-bold pt-5">
کیفیت تضمین شده 
              </p>
              <p class="mb-4">
از آن‌جایی که کیفیت پرینت به طور مستقیم بر کیفیت مطالعه اثر می‌گذارد، حساسیت کاربران بر روی کیفیت دو چندان شده است.<br />
این موضوع اعتماد به سایت‌های پرینت آنلاین را کاهش می‌دهد. زیرا کاربران جزوه و یا کتاب چاپ شده را در زمان تحویل خواهند دید و فکر می‌کنند در صورت پایین بودن کیفیت چاپ، دیگر کاری از دستشان برنمی‌آید.<br />
زیراکسی از دغدغه مشتریان خودآگاه است و همیشه تلاش می‌کند مشتریان را راضی نگه دارد و خدماتی متناسب با نیاز کاربران ارائه کند. این مجموعه با تکیه بر دستگاه‌های به‌روز و مواد اولیه باکیفیت، تمام خدمات خود را تضمین کیفیت می‌کند.<br />
چنانچه کتاب و یا جزوه چاپ شده از کیفیت مناسبی برخوردار نباشد پس از اثبات این موضوع، زیراکسی خود را موظف می‌داند، پرینت کتاب و یا جزوه را به طور مجدد انجام دهد و برای مشتری به‌صورت رایگان ارسال کند و یا مبلغ پرداختی را به‌حساب و یا کیف پول او واریز کند. مجموعه زیراکسی در حین انجام سفارش‌ها کنترل کیفیت مداوم دارد تا هر مرحله به‌درستی و باکیفیت مطلوب انجام شود که این موضوع باعث می‌شود اطمینان کاربران از خدمات زیراکسی دوچندان شود.<br />
با زیراکسی از کیفیت چاپ خود اطمینان کامل داشته باشید.  
           </p>
              <p  class="mb-4 fw-bold pt-5">
             ارسال فوری در کمترین بازه زمانی ممکن
              </p>
              <p class="mb-5">
ثبت سفارش در سامانه چاپ آنلاین زیراکسی برای همه کاربران در سراسر ایران در کم‌ترین بازه زمانی ممکن و در بالاترین سرعت انجام می‌شود؛ اما بازه زمانی ارسال از لحظه ثبت سفارش تا لحظه تحویل با توجه به فاصله کاربران از شعب زیراکسی متفاوت است. <br />
با توجه به اینکه شعبه‌های شرکت زیراکسی در شهرهای اصفهان و تهران واقع شده است، بازه زمانی سفارش تا تحویل در این دو شهر کمتر از 24 ساعت انجام می‌شود و از آن‌جایی که ارسال در بقیه شهرها با پست انجام می‌شود دو تا سه روز کاری طول خواهد کشید.
              </p>
            
              `,
      line_content: `
      در سامانه چاپ آنلاین زیراکسی، پرینت آنلاین ارزان و باکیفیت را تجربه کنید
              `,
      button_text: 'ثبت سفارش',
      line_button: false,
      router_link: 'backAndWhitePrint',
    },
    questions: [
      {
        question: `
        آیا در صورت نارضایتی مشتری از کیفیت پرینت، امکان باز ارسال و یا عودت وجه وجود دارد؟
        `,
        answer: `
بله قطعاً. زیراکسی تمام خدمات خود را تضمین کیفیت کرده است و در صورتی که کیفیت سفارش شما پایین باشد بعد از اثبات این موضوع، به‌سرعت سفارش شما باز ارسال خواهد شد و یا در صورت تمایل مشتری هزینه پرداخت شده به کیف پول و یا حساب مشتری بازمی‌گردد.        `,
        id: '1',
      },
    ],
  },
  cheapPrint: {
    color: '#EFFFDC',
    header: 'پرینت ارزان و باکیفیت',
    desc: 'در سامانه چاپ آنلاین زیراکسی',
    why_ziraxi: {
      responsive_title: {
        title1: 'پرینت',
        title2: 'ارزان',
      },
      background_alt: 'پرینت ترکیبی، ترکیبی از پرینت سیاه و سفید و رنگی است ',
      background_src: 'cheap-print',
      background_postfix: '.webp',
      background_color: '#DCEBFF',
      first_content: `<p class="mb-4 fw-bold">
                 پرینت ارزان و ضرورت آن   
                </p>
                <p class="mb-5">
                  این روزها جای خالی مجموعه‌ای که بتواند پرینت ارزان و باکیفیت ارائه دهد، در زندگی هر دانشجو یا دانش‌آموزی حس می‌شود؛ چراکه قیمت پرینت و کپی به‌شدت افزایش یافته و همین امر باعث شده است که دانش‌آموزان و دانشجویان، کمتر جزوات و کتاب‌های خود را پرینت کرده و به استفاده از پی‌دی‌اف و کتاب‌های الکترونیک روی آورند. اما داستان اینجا به پایان نمی‌رسد و مشکلات بیشتری پیش روی این افراد است.<br />
                </p>
                <p class="mb-4 fw-bold">
                آسیب‌های استفاده از کتاب‌های الکترونیک
                </p>
                <p>
طبق تحقیقات انجام شده، استفاده از پی‌دی‌اف و کتاب‌های الکترونیک باعث کاهش تمرکز، خستگی زودهنگام و آسیب چشم‌ها در بلندمدت می‌شود. اگر مجموعه‌ای باشد که بتواند چاپ ارزان و با کیفیت بالایی را به مخاطبان ارائه دهد، بخش زیادی از این مشکلات حل خواهد شد. 
                </p>
                <p class="mb-4 fw-bold">
                  زیراکسی، ارائه‌دهنده پرینت ارزان و باکیفیت 
                </p>
                <p>
مجموعه‌های زیادی در تلاش هستند تا هزینه‌های ناشی از چاپ را کاهش دهند و متأسفانه تعداد بسیاری از آن‌ها برای تحقق این موضوع از مواد نامرغوب و ارزان‌قیمت استفاده می‌کنند. چنین مجموعه‌هایی دوام چندانی ندارند؛ چراکه این روند در بلندمدت نارضایتی مشتریان را به دنبال خواهد داشت.</p>
                `,
      secound_content: `
                <p class="mb-5">
                اما مجموعه‌هایی هم هستند که برای ارائه چاپ ارزان و باکیفیت، از روش‌های مبتکرانه‌ای استفاده می‌کنند. یکی از معتبر‌ترین این مجموعه‌ها، سامانه چاپ آنلاین زیراکسی است.این مجموعه برای محقق کردن هدف خود یعنی ارائه چاپ ارزان و باکیفیت، توانسته پلتفرمی ساده و منحصربه‌فرد راه‌اندازی کند و با روش‌های متنوع، هزینه تمام شده پرینت برای مشتریان خود را به حداقل مقدار ممکن برساند. برای دیدن تعرفه زیراکسی بر روی <a href="/price-list/black-and-white-print-price"> قیمت پرینت </a> کلیک کنید.
                </p>
                <p class="mb-4 fw-bold">
روش‌های کاهش قیمت پرینت در زیراکسی
                </p>
                <p class="mb-5">
                زیراکسی کاغذ مصرفی خود را به طور مستقیم از کارخانه تهیه کرده و دست واسطه را از میان برداشته است. همچنین مواد اولیه مورد استفاده شامل تونرهای باکیفیت، فنر، و غیره را به‌صورت عمده خریداری می‌کند و هزینه مصرفی خود را به‌شدت کاهش می‌دهد. نهایتاً زیراکسی توانسته با استفاده از دستگاه‌های تکثیر به‌روز دنیا و دستگاه‌های تمام لیزر، هزینه تعمیر و نگهداری آن‌ها را به حداقل برساند. مجموع این عوامل باعث شده است تا این مجموعه بتواند کلیه خدمات خود را با قیمتی مناسب و کیفیتی عالی به مشتریان خود ارائه کند.
                </p>
                <p class="mb-4 fw-bold">
                دیگر ویژگی‌های منحصربه‌فرد زیراکسی 
                </p>
                <p class="mb-4">
از دیگر ویژگی‌های مهم مجموعه زیراکسی، داشتن سایتی کاربردی و کاربرپسند است. تخصص و دقت بالا در طراحی وب‌سایت زیراکسی، باعث شده تا کاربران بتوانند با هر دستگاهی (موبایل، لپتاپ و ...) به‌راحتی و بدون مشکل سفارش خود را ثبت کنند.<br />
 همچنین مجموعه زیراکسی دارای یک تیم پشتیبانی شبانه‌روزی است که در صورت بروز هر گونه مشکل، در کمترین زمان ممکن آن را برطرف خواهند کرد.<br />
<a href="/booklet-print"> چاپ جزوه </a> و کتاب‌های خود را به زیراکسی بسپارید و پرینتی ارزان و مقرون‌به‌صرفه داشته باشید.
</p>
              `,
      third_content: `
              <p  class="mb-4 fw-bold mt-5 pt-5">
پرینت ارزان با ارسال رایگان
              </p>
              <p class="mb-3">
افزایش هزینه‌های ارسال و تمایل کابران برای پرداخت هزینه کمتر، باعث شد تا مجموعه زیراکسی راه‌های زیادی را برای بهره‌وری مشتری از پرینت ارزان با ارسال رایگان ایجاد کند.<br />
 مشتریان زیراکسی برای بهره بردن از ارسال رایگان، می‌توانند روش‌های زیر اقدام کنند:
</p>
<p class="mb-3 me-5">
۱)	سفارش بالای 900,000 تومان <br />
در صورتی که سفارش شما بالای 900,000 تومان باشد، هزینه ارسال برای شما رایگان خواهد بود.<br />
با انجام سفارش خود و دوستانتان به صورت همزمان، به راحتی می‌توانید از این امکان استفاده کرده و سفارش خود را با ارسال رایگان تحویل بگیرید.
</p>
<p class="mb-3 me-5">
2)	 استوری در اینستاگرام <br />
از سفارش خود عکس بگیرید و یا بسته ارسال شده را انباکس کنید. بعد از آن، عکس یا فیلم خود را در اینستاگرام استوری کرده و زیراکسی را منشن کنید. پس از گذشت 12 ساعت و بازدید حداقل 70 نفر از استوری، یک ارسال رایگان از زیراکسی هدیه می‌گیرید.
</p>
                        
              `,
      line_content: `
      `,
      button_text: 'ثبت سفارش',
      line_button: true,
      router_link: 'backAndWhitePrint',
    },
    questions: [
      {
        question: `
          آیا پایین‌بودن تعرفه خدمات در زیراکسی نشانه پایین‌بودن کیفیت است؟
        `,
        answer: `
خیر به‌هیچ‌عنوان این‌گونه نیست. همان‌طور که قبلاً گفته شد کاهش هزینه‌ها برای مشتریان به این دلیل است که زیراکسی هزینه تمام شده برای خود را کاهش داده است. زیراکسی با تکیه بر نیروی انسانی متخصص و دستگاه‌های به روزی که دارد، کلیه خدمات خود را تضمین کیفیت کرده است و همواره تلاش می‌کند رضایت مشتریان خود را جلب کند.
`,
        id: '1',
      },
      {
        question: 'هزینه پرینت سیاه و سفید زیراکسی چند درصد پایین‌تر از نرخ پرینت سیاه ‌و سفید اتحادیه است؟',
        answer: `
هزینه پرینت سیاه‌ و سفید در زیراکسی 80 درصد پایین از نرخ پرینت اتحادیه است. (همچنین شما می‌توانید با استفاده از بسته‌های زیراکسی این هزینه را بیشتر کاهش دهید). در این بخش <a href="/price-list/black-and-white-print-price"> قیمت پرینت سیاه و سفید </a> توضیحات مربوط به این را مشاهده و ثبت سفارش کنید.
`,
        id: '2',
      },
      {
        question: 'هزینه پرینت رنگی در زیراکسی چند درصد پایین‌تر از نرخ پرینت رنگی اتحادیه است؟',
        answer: `<p>
        زیراکسی پرینت رنگی خود را به دو بخش پرینت رنگی (برای صفحات تمام ‌رنگ) و پرینت نیمه‌ رنگی (برای صفحاتی که پس‌زمینه سفید دارد و یا کمتر از 50 درصد آن رنگی باشد) تقسیم کرده است.
        <br/>
هزینه پرینت رنگی در زیراکسی 83 درصد و هزینه پرینت نیمه ‌رنگی 86 درصد پایین‌تر از نرخ پرینت اتحادیه است. در بخش <a href="/price-list/full-color-print-price"> قیمت پرینت رنگی </a> توضیحات کامل‌تر را مشاهده و ثبت سفارش کنید.
</p>
`,
        id: '3',
      },
      {
        question: 'زیراکسی چه خدماتی را ارائه می‌دهد؟',
        answer: `
        زیراکسی ارائه‌دهنده خدماتی همچون پرینت سیاه ‌و سفید، پرینت رنگی، پرینت نیمه ‌رنگی و پرینت ترکیبی است و علاوه بر این خدمات، این مجموعه خدماتی همچون صحافی و ویرایش پایان‌نامه و مقاله را نیز به دانشجویان ارائه کرده است.
`,
        id: '4',
      },
    ],
  },
  bookletPrint: {
    color: '#DDDCFF',
    header: 'چاپ جزوه ارزان و باکیفیت',
    desc: 'در سامانه چاپ آنلاین زیراکسی ',
    why_ziraxi: {
      responsive_title: {
        title1: 'چاپ',
        title2: 'جزوه',
      },
      background_alt: 'پرینت ترکیبی، ترکیبی از پرینت سیاه و سفید و رنگی است ',
      background_src: 'booklet-print',
      background_postfix: '.webp',
      background_color: '#FFEEDC',
      first_content: `<p class="mb-4 fw-bold">
                        چاپ جزوه
                      </p>
                <p class="mb-3">
                  از جمله خدماتی که دانشجویان و دانش‌آموزان روزانه با آن سر و کار دارند، چاپ جزوه است. دلایل زیادی وجود دارد که این افراد، از نسخه چاپی به‌جای نسخه الکترونیک استفاده کنند.
                  طبق تحقیقات انجام شده، استفاده از پی‌دی‌اف و کتاب‌های الکترونیک باعث آسیب رسیدن به چشم‌ها در بلندمدت، خستگی زودهنگام ذهن و غیره می‌شود. به همین دلیل استفاده از کتاب و جزوه چاپ شده همواره گزینه بهتری برای مطالعه است.         
                </p>                
                `,
      secound_content: `
      <p class="mb-4 fw-bold">
        چاپ جزوه آنلاین
      </p>
                <p class="mb-3">
درگذشته چاپ کتاب و جزوه، فرایندی بسیار وقت‌گیر بود. چراکه زمان زیادی در صف‌های طولانی و ترافیک سپری می‌شد. اما امروزه با تغییرات گسترده‌ای که در دنیای دیجیتال اتفاق افتاده است حتی چاپ جزوه هم به‌صورت آنلاین انجام می‌شود.
یکی از مراکزی که در زمینه چاپ آنلاین فعالیت دارد، مجموعه زیراکسی است که همواره تلاش می‌کند خدمات خود را با کمترین قیمت و بهترین کیفیت به مشتریان خود ارائه کند.<br />
دلایل زیادی وجود دارد که کاربران، این مجموعه را برای خدمات پرینت انتخاب کنند. یکی از مهم‌ترین ویژگی‌های زیراکسی ارزان‌بودن خدمات آن است به‌گونه‌ای که <a href="/price-list/black-and-white-print-price" > تعرفه پرینت سیاه و سفید </a> در زیراکسی یک دهم و <a href="/price-list/full-color-print-price" > تعرفه پرینت رنگی </a> در این مجموعه یک پنجم نرخ اتحادیه کپی و پرینت است.<br />
از دیگر ویژگی‌های این مجموعه می‌توان به کیفیت بالا خدمات، پشتیبانی 24 ساعته و غیره نیز اشاره کرد. مجموع این عوامل باعث شده کاربران بتوانند چاپ جزوه ارزان و با کیفیتی داشته باشند و با خیال راحت در زیراکسی ثبت سفارش کنند.
                </p>
                <p class="mb-5">
با زیراکسی  <a href="/cheap-print"> چاپ ارزان </a>و باکیفیت داشته باشید و بدون اتلاف وقت جزوات خود را پرینت کنید  
                </p>
              `,
      third_content: `
              <p  class="mb-4 fw-bold mt-3 pt-5">
                هزینه چاپ جزوه
              </p>
              <p class="mb-3">
عوامل متعددی در هزینه چاپ جزوه می‌تواند تأثیرگذار باشد که از جمله این عوامل می‌توان به موارد زیر اشاره کرد:
</p>
   <ul class="pe-0">
          <p class="mb-4 fw-bold me-5">
1. تعداد صفحات جزوه:
          </p>
          <p class="me-5">
تعداد صفحات جزوه مورد نظر و همچنین یک رو یا دو رو بودن صفحات پرینت شده، در هزینه نهایی چاپ اثرگذار است. ازآنجایی‌که هزینه پرینت پشت و رو از هزینه دو صفحه یک رو پرینت شده کمتر است، تمایل کاربران برای گرفتن پرینت دو رو بیشتر است.          </p>
          <p class="mb-4 fw-bold me-5">
2. نوع پرینت:
          </p>
          <p class="me-5">
 یکی از مهم‌ترین عوامل تأثیرگذار در هزینه تمام شده سفارش، نوع پرینت است. در زیراکسی شما می‌توانید جزوه و کتاب‌های خود را به‌صورت سیاه و سفید، تمام رنگی، نیمه رنگی و ترکیبی پرینت کنید.<br />
اگر کل صفحات یک جزوه تنها دارای متن است، پیشنهاد می‌شود سفارش خود را به‌صورت سیاه و سفید پرینت کنید و هزینه‌های خود را تا حد ممکن کاهش دهید. درصورتی‌که قصد گرفتن پرینت رنگی دارید، چنانچه صفحات فایل مورد نظر شما کمتر از 50 درصد تصاویر رنگی دارد، گزینه نیمه رنگی را انتخاب کنید و اگر بیشتر از 50 درصد دارای تصاویر رنگی است، گزینه تمام رنگی را انتخاب کنید.<br />
 گاهی کاربران تمایل دارند تعدادی از صفحات فایل خود را به‌صورت سیاه و سفید و تعدادی از صفحات را به‌صورت رنگی پرینت کنند که در این صورت، پیشنهاد می‌شود پرینت ترکیبی را انتخاب کنید.<br />
معمولاً هزینه پرینت تمام رنگی نسبت به نیمه ‌رنگی و سیاه و سفید بالاتر است؛ به همین دلیل دانشجویان و دانش‌آموزان برای پرینت جزوات خود، در اغلب موارد از پرینت سیاه و سفید استفاده می‌کنند.
          </p>
          <p class="mb-4 fw-bold me-5">3. نوع صحافی:</p>
          <p class="me-5">برای‌آنکه جزوه پرینت شده ظاهر مناسبی داشته باشد و با گذر زمان آسیب کمتری ببیند، بهتر است صحافی مناسبی داشته باشد. از جمله صحافی‌هایی که برای جزوه مناسب است می‌توان به موارد زیر اشاره کرد.</p>
          <li class="me-70">
          طلق و شیرازه:
          <p>
          صحافی با طلق و شیرازه یکی از روش‌های متداول مورد استفاده دانشجویان و دانش‌آموزان است؛ زیرا هزینه کمتری برای آنها دارد. قابل‌ذکر است که این نوع صحافی معمولاً برای جزوه‌هایی با کمتر از 100 صفحه مورد استفاده قرار می‌گیرد.
          </p>
          </li>
          <li class="me-70">
            منگنه:
            <p>
            صحافی به‌وسیله منگنه، در برابر آسیب‌هایی مانند پارگی صفحات، خیس شدن و… محافظ نبوده و ظاهر خاصی به جزوه نمی‌دهد. به همین دلیل از آن معمولاً برای جلوگیری از به‌هم‌ریختگی صفحات چاپ شده و برای جزواتی با کمتر از 50 صفحه، استفاده می‌شود.
            </p>
          </li>
          <li class="me-70">
            سیمی فلزی (فنری):
            <p>
            این نوع صحافی، متداول‌ترین نوع صحافی جزوه بوده و برای جزوه‌هایی تا 450 صفحه مورد استفاده قرار می‌گیرد. سیمی فلزی، امکان چرخش 360 درجه را برای جزوه‌ها فراهم کرده و به این دلیل از محبوبیت بالایی برخوردار است.   <br />          
            </p>
          </li>
          <li class="me-70">
            سیمی پلاستیکی:
          <p>
          صحافی سیمی پلاستیکی، برای جزوه‌هایی تا 50 صفحه مناسب بوده و بر خلاف استفاده از منگنه، ظاهر مناسبی به جزوه بخشیده و ورق‌زدن را راحت‌تر می‌کند.
          </p>
          </li>
          <li class="me-70">
            صحافی گالینگور:
            <p>
این نوع صحافی، اغلب برای کتاب‌ها، مقالات و پایان ‌نامه دانشجویان مورد استفاده قرار می‌گیرد. <a href="/thesis-binding">صحافی گالینگور</a> ، نوعی صحافی جلد سخت بوده و انواع متن و تصویر بر روی جلد آن قابل حکاکی است. جلد ضخیم و محکم مورد استفاده و همچنین نوشته‌های طلاکوب روی آن، این نوع صحافی را به یکی از زیباترین انواع صحافی تبدیل کرده است.
</br>
سامانه <a href="/online-print"> پرینت آنلاین </a> زیراکسی تمام تلاش خود را می‌کند تا جزوات شما را در بالاترین کیفیت و با کمترین هزینه ممکن چاپ کند. در پنل سفارش گیری ثبت سفارش کنید و از داشتن جزوه‌ای ارزان و با کیفیت لذت ببرید.
</p>
          </li>
        </ul>      
              `,
      line_content: 'با زیراکسی چاپ ارزان و باکیفیت داشته باشید و بدون اتلاف وقت جزوات خود را پرینت کنید.',
      button_text: 'ثبت سفارش',
      line_button: false,
      router_link: 'backAndWhitePrint',
    },
    questions: [],
  },
  ThesisOrder: {
    color: '#F2DCFF',
    header: 'پرینت و صحافی پایان‌نامه',
    desc: 'در سامانه چاپ آنلاین زیراکسی',
    why_ziraxi: {
      responsive_title: {
        title1: 'پرینت و صحافی',
        title2: 'پایان‌نامه',
      },
      background_alt: 'صحافی پایان‌نامه با گالینگور در بالاترین کیفیت',
      background_src: 'thesis',
      background_postfix: '.webp',
      background_color: '#DCF7FF',
      first_content: `<p class="mb-4 fw-bold">
            صحافی پایان ‌نامه 
            </p>
            <p class="mb-5">
            امروزه، با توجه به پیشرفت تکنولوژی، حتی چاپ و صحافی پایان ‌نامه هم به‌صورت آنلاین انجام می‌شود.
            یکی از بهترین مجموعه‌هایی که در پرینت و صحافی پایان ‌نامه فعالیت دارد، مجموعه چاپ آنلاین زیراکسی است که همواره تلاش می‌کند خدمات خود را با بهترین کیفیت به کاربران خود ارائه کند.<br />
            از مهم‌ترین ویژگی‌های این مجموعه می‌توان به داشتن کادری متخصص و همچنین استفاده کردن از بهترین دستگاه‌های صحافی اشاره کرد که باعث می‌شود صحافی در بالا‌ترین دقت و حساسیت ممکن انجام شود.
            </p>
            
            `,
      secound_content: `
            <p class="mb-4 fw-bold">
            صحافی گالینگور پایان ‌نامه در بالاترین کیفیت و دقت
            </p>
            <p class="mb-5">
           از آن‌جایی که صحافی گالینگور طرفداران زیادی دارد و بیشتر برای پایان ‌نامه استفاده می‌شود، زیراکسی نیروهای ویژه و مجربی را برای انجام آن قرار داده است تا پایان‌ نامه با بهترین کیفیت و در قالب استاندارد دانشگاه مورد نظر صحافی شود و رضایت دانشجویان به طور کامل جلب کند. بر روی صحافی گالینگور می‌توان عنوان را به‌صورت طلاکوب و یا نقره‌کوب درج کرد که زیراکسی این کار را با بهترین کیفیت و قیمتی مناسب برای کاربران خود انجام می‌دهد. برای دیدن تعرفه‌ها ، بر روی <a href="/price-list/binding-price" > قیمت صحافی </a> کلیک کنید
            </p>
            <p class="mb-4 fw-bold">
            منحصربه‌فردترین سایت صحافی پایان ‌نامه و مزایای آن
            </p>
            <p class="mb-5">
            یکی از ویژگی‌های مهم زیراکسی داشتن وب‌سایتی منحصر به فرد و کاربردی برای سفارش پرینت و صحافی پایان‌ نامه است. دانشجویان می‌توانند علاوه بر فایل پایان‌ نامه، امضای استاد و طرح دلخواه روی جلد پایان‌ نامه را نیز آپلود کنند، تا سفارش آنها مطابق میل و در بالاترین دقت انجام شود.
            <br/>
            همچنین در این مجموعه پرینت و صحافی پایان ‌نامه با سرعت بالایی انجام می‌شود کاربران می‌توانند بدون اتلاف وقت و در کمترین بازه زمانی ممکن، صحافی دقیق و زیبا از پایان ‌نامه خود داشته باشند و در وقت و هزینه خود صرفه‌جویی کنند.
            </p>
          `,
      line_content: `
          با سامانه چاپ آنلاین زیراکسی، در بهترین کیفیت و با قیمتی مناسب، پایان‌نامه خود را صحافی کنید
          `,
      button_text: 'ثبت سفارش',
      line_button: false,
      router_link: 'thesis',
      third_content: `
          <p class="mb-5">
          هزینه پایین و کیفیت بالای چاپ از دیگر ویژگی‌های مهم زیراکسی است. هزینه پرینت در این مجموعه بسیار پایین‌تر از نرخ اتحادیه است. به طوری که کاربران می‌توانند با توجه به حجم سفارشی که دارند تا 90  درصد در هزینه‌ها
          صرفه‌جویی کنند. برای دیدن تعرفه‌ها در زیراکسی بر روی <a href="/price-list/black-and-white-print-price" > قیمت پرینت  </a> کلیک کنید.
          </p>
          <p class="mb-4 fw-bold pt-5">
          صحافی چیست؟
          </p>
          <p class="mb-5">
          به زبانی ساده، به ترتیب قراردادن صفحات و به هم پیوستن مرتب آن‌ها، صحافی نام دارد. به‌عبارت‌دیگر، آخرین مرحله از تولید یک کتاب، مجله، پایان ‌نامه و غیره صحافی آن است. با وجود تعریف ساده، این مرحله از چاپ کار بسیار حساسی بوده و نقش مهمی در شکل‌گیری سفارش نهایی دارد.
          </p>
          <p class="mb-4 fw-bold pt-5">
          انواع صحافی
          </p>
          <p>
          صحافی، انواع متنوعی دارد که نویسنده متناسب با هدف، کاربرد نهایی و تعداد صفحات کتاب و مقالات خود، یکی از انواع آن را انتخاب می‌کند. انواع صحافی از منظرهای مختلفی قابل‌دسته‌بندی است که عبارت‌اند از:
          </p>
          <ul class="pe-0">
          <p class="pe-5">1. از نظر اجرا</p>
          <li class="me-70">
            دستی یا سنتی:
            <br/>
            <p>
            صحافی دستی، معمولاً برای آثار نفیس هنری مورد استفاده قرار می‌گیرد. در این روش تمام مراحل، از شکافتن ورقه‌های کتاب گرفته تا ته‌دوزی آن‌ها، اضافه‌کردن جلد و طلاکوبی با دست انجام می‌شود.
            </p>
          </li>
          <li class="me-70">
            ماشینی: 
            <br/>
            <p>
            صحافی ماشینی، عموماً مختص کتاب‌ها، مجلات و مقالات چاپی است. تمام مراحل آن شامل تا شدن ورقه‌های کتاب، چیده شدن و انباشته‌شدن آن‌ها بر روی‌هم و در نهایت چسب خوردن و جلدشدن، توسط ماشین‌های مخصوص صحافی انجام می‌شود.
            </p>
          </li>
          <p class="pe-5">2. از نظر روش اتصال</p>
          <li class="me-70">
            صحافی ته‌چسب: 
            <br/>
            <p>
            صحافی ته‌چسب، به دو روش زیر انجام می‌شود:
            </p>
            <p>
            صحافی چسب گرم: صحافی چسب گرم یا صحافی حرارتی، یکی از متداول‌ترین روش‌های صحافی است. دلیل متداول بودن این روش، سریع خشک شدن چسب گرم است. این روش، پس از سرد شدن، استحکام و ماندگاری زیادی را به همراه دارد و هر محصول چاپ‌شده‌ای را با دوام بالا در اختیار مشتریان قرار می‌دهد.
            </p>
            <p>
              صحافی چسب سرد: روش کار این نوع صحافی با صحافی چسب گرم یکسان است، با این تفاوت که چسب سرد پایدارتر بوده، در معرض گرما و حرارت فعال نشده و در سرما نیز نمی‌شکند. از دیگر مزایای صحافی چسب سرد، این است که چسب مورد استفاده در آن قابل بازیافت است و آسیب کمتری به محیط‌زیست وارد می‌کند.
            </p>
          </li>
          <li class="me-70">
            صحافی فنری (سیمی کردن):
            <br/>
            <p>
            احتمالاً اصطلاح سیمی کردن کتاب، به گوشتان خورده است. روش صحافی فنری که به آن صحافی سیمی نیز گفته می‌شود، یکی از روش‌های رایج صحافی برای کتاب‌ها یا مقالاتی یا صفحات کم به شمار می‌آید. از مزیت‌های صحافی فنری، می‌توان به‌سرعت بالای آن و ایجاد ظاهری زیبا در کتاب و جزوه اشاره کرد. همچنین این نوع صحافی، ورق زدن صفحات را ساده‌تر می‌کند و احتمال پاره شدن صفحات را به حداقل می‌رساند.
            </p>
          </li>
          <li class="me-70">
            صحافی منگنه‌ای:
            <br/>
            <p>
            صحافی منگنه‌ای معمولاً برای بروشور، جزوات و مقالات کم‌حجم مورد استفاده قرار می‌گیرد. در صورت استفاده از این روش برای صفحات چاپ شده با ضخامت بالا، محصول نهایی از استحکام کمی برخوردار بوده و خیلی زود زیبایی ظاهری و کیفیت خود را از دست می‌دهد. این نوع صحافی، با سرعت بالاتری نسبت به روش‌های قبلی انجام می‌شود و هزینه نهایی کمتری را برای مشتریان به همراه دارد.
            </p>
          </li>
          <p class="pe-5">
      3. از نظر نوع جلد
          </p>
          <li class="me-70">
            صحافی جلد نرم یا شومیز:
            <p>
            در این نوع صحافی، جلد به کار برده شده، از جنس مقواهای نازک با انعطاف‌پذیری زیاد (معمولاً کاغذگلاسه‌ای با وزن 250 گرم) است. تعداد برگه‌هایی که با این روش می‌توان به هم متصل کرد، نامحدود است و تقریباً تا قطر 7 سانتی‌متر می‌توان این کار را انجام داد؛ بنابراین این روش برای مجلات که تعداد صفحات کمی دارد، مناسب نیست.
            </p>
          </li>
          <li class="me-70">
            صحافی جلد سخت:
            <p>
            در صحافی جلد سخت، ابتدا صفحات با استفاده از چسب به هم متصل می‌شوند؛ سپس آن‌ها را به جلدی از جنس مقواهای ضخیم متصل می‌کنند. این روش انواع گوناگونی دارد. از جمله انواع جلد سخت می‌توان به مواد زیر اشاره کرد:
            </p>
            جلد سخت سلفون
            </p>
            <p>
              در صحافی جلد سخت سلفون، ابتدا جلد به‌صورت مجزا با مقواهای بسیار ضخیم چاپ می‌شود، با استفاده از سلفون روکش‌کاری شده و در نهایت به صفحات، اتصال داده می‌شود.
            </p>
            <p>
              جلد سخت چرمی
            </p>
            <p>
              در این نوع صحافی، از جلدهایی از جنس چرم استفاده می‌کنند و بر روی آن، طرح‌های مختلفی حکاکی می‌شود. از صحافی جلد سخت چرمی، بیشتر برای کتب نفیس مانند قرآن، کتاب حافظ و... استفاده می‌شود.
            </p>
            <p>
              جلد سخت گالینگور
            </p>
            <p>
              برای انجام این نوع صحافی، ابتدا برگه‌های محصول چاپ شده مرتب می‌شود، سپس کناره‌های آن را کمی چسب می‌زنند و بعد از آن جلد را که معمولاً از جنس مقوا است، به آن می‌چسبانند. در نهایت، مقوا با لایه‌ای چرم‌مانند از جنس گالینگور، پوشانده می‌شود.
              <br/>
              صحافی گالینگور، بیشتر برای پایان ‌نامه و پروژه مورد استفاده قرار می‌گیرد و به همین دلیل در میان دانشجویان از محبوبیت بالایی برخوردار است. دلیل این نام‌گذاری، نوع پارچه مورد استفاده در جلد است که با نام تجاری گالینگور شناخته می‌شود.
              </br>
              استفاده از این نوع صحافی استحکام بالایی داشته و باعث ماندگاری طولانی‌مدت محصولات چاپ شده، می‌شود. همچنین به دلیل وجود ستون فقرات در بخش میانی آن، این نوع جلد بسیار نرم است. زمانی که کتاب، مقاله و... بر روی سطح صاف قرار دارد، این ویژگی باعث می‌شود که بر اساس تعداد صفحاتش باز بماند و به‌قول‌معروف صفحه گم نشود. امکان حک کردن نوشته بر روی جلد به‌صورت طلاکوب و نقره‌کوب، ویژگی دیگری از صحافی گالینگور است که به زیبایی ظاهری آن اضافه می‌کند.
            </p>
          </li>
        </ul>
        <p>
          `,
    },
  },
  ThesisEditOrder: {
    color: '#DDDCFF',
    header: 'ویرایش پایان‌نامه با بالاترین کیفیت',
    desc: 'در سامانه چاپ آنلاین زیراکسی',
    why_ziraxi: {
      responsive_title: {
        title1: 'پرینت',
        title2: '',
      },
      background_alt: 'ویرایش پایان‌نامه به‌صورت فنی در بالاترین دقت و کیفیت',
      background_src: 'thesis-edit',
      background_postfix: '.webp',
      background_color: '#E0FFDC',
      first_content: `<p class="mb-4 fw-bold">ویرایش پایان‌نامه آنلاین</p>
          <p class="mb-5">
          از جمله خدماتی که این روزها به‌صورت آنلاین انجام می‌شود ویرایش پایان نامه است؛ چرا که با پیشرفت تکنولوژی و استفاده گسترده از اینترنت، افراد ترجیح می‌دهند به‌جای خرید حضوری محصولات و یا استفاده از خدمات به‌صورت سنتی، از خدمات آنلاین برای رفع نیازهای خود استفاده کنند.
          <br/>
          روی‌آوردن افراد به استفاده از خدمات آنلاین دلایل زیادی دارد که می‌توان به صرفه‌جویی در هزینه و زمان، عدم محدودیت جغرافیایی، راحتی مبادله و... اشاره کرد. همین موارد باعث شده تا ویرایش پایان ‌نامه نیز به این حوزه راه پیدا کرده و راحتی و رضایت دانشجویان را به همراه داشته باشد.
          </br>
          زیراکسی، به‌عنوان کابردی‌ترین سامانه چاپ آنلاین ، به‌منظور رفاه هر چه بیشتر دانشجویان، ویرایش پایان‌ نامه را نیز به لیست خدمات خود اضافه کرده تا آنها بتوانند با صرفه‌جویی در زمان و هزینه، همه مراحل آماده‌سازی پایان ‌نامه از ویرایش تا پرینت و صحافی پایان نامه را به‌صورت یک‌جا و باکیفیت بالا انجام دهند و این خدمات را در کمترین بازه زمانی ممکن دریافت کنند.
          </p>
          `,
      secound_content: `
          <p class="mb-4 fw-bold">
          چرا دانشجویان به ویرایش پایان ‌نامه نیاز دارند؟
          </p>
          <p class="mb-5">
          هر متنی از نوشتن پیامی ساده گرفته تا نوشتن یک کتاب، برای انتقال درست مفاهیم، به ویرایش نیاز دارد.<br />
          این موضوع برای دانشجویانی که در تکاپوی نوشتن پایان ‌نامه هستند، از اهمیت بالایی برخوردار است؛ چرا که پایان ‌نامه، حاصل چند سال تلاش دانشجویان در مقاطع تحصیلی مختلف است. همچنین انگیزه استخراج مقاله از پایان‌ نامه، باعث می‌شود تا دانشجویان با تمرکز بیشتری به بالا بردن سطح کیفی پایان‌ نامه خود بپردازند.          </p>
          <p class="mb-4 fw-bold mt-3">
          ویرایش پایان ‌نامه چیست؟
          </p>
          <p class="mb-5">
          ویرایش برای اصلاح ایرادات محتوایی و نگارشی متون، از جمله اقداماتی است که دانشجویان در طول زمان تحصیل باید انجام دهند.<br />
 این کار باید توسط ویراستار متخصص انجام شود؛ کسی که توانایی تصحیح خطاهای مربوط به دستور زبان، ساختار آن، علائم نگارشی و… را داشته باشد. گاهی اوقات برای ویرایش پایان‌ نامه نیاز است تا ویرایشگر دانش موضوعی خاصی داشته و بر اساس آن متن را اصلاح کند.
          </p>
          <p class="mb-4 fw-bold mt-3">
          انواع ویرایش پایان‌نامه
          </p>
          <p class="mb-5">
          همان‌طور که پیش‌تر گفته شد، ویرایش پایان‌ نامه امری ضروری به‌حساب می‌آید. زمانی که پایان‌ نامه به‌صورت تخصصی و بدون هیچ ایراد نگارشی ارائه می‌شود، کیفیت آن به حداکثر ممکن رسیده و در نظر ارزیابان، تأثیر مثبتی خواهد داشت. در ادامه انواع ویرایش پایان ‌نامه بررسی خواهد شد.
          </p>
          <p class="mb-4 fw-bold mt-3 me-5">
          1. ویرایش تخصصی
          </p>
          <p class="mb-5 me-5">
          اولین گام بعد از اتمام نگارش پایان ‌نامه، ویرایش تخصصی آن است که به ویرایش علمی نیز معروف است. دلیل این نام‌گذاری این است که این نوع ویرایش به طور مستقیم با جنبه‌های علمی متن در ارتباط است. در ویرایش تخصصی، صحت اطلاعات ارائه شده در پایان ‌نامه سنجیده می‌شود و ویراستار باید از اینکه نحوه بیان این اطلاعات در چارچوب موازین علمی است، اطمینان حاصل کند.
          <br/>
          به طور معمول دانشجویان نمی‌توانند پایان‌ نامه خود را از نظر علمی ویرایش کنند و این کار باید توسط یک ویراستار علمی انجام شود. این ویراستار باید از نظر سطح علمی از نویسنده پایان ‌نامه بالاتر بوده و دانش و تخصص او با موضوع پایان ‌نامه مرتبط باشد.
          </p>
          <p class="mb-4 fw-bold mt-3 me-5">
          2. ویرایش محتوایی
          </p>
          <p class="mb-5 me-5">
          در ویرایش محتوایی، همان‌طور که از نامش پیداست، تمرکز بر محتوای متن است و به مفهوم و ساختار متن توجه می‌شود. در این نوع ویرایش، ویراستار تلاش می‌کند تا هرگونه سوءبرداشت از مفاهیم نوشته را برطرف کند و این کار را با جابه‌جایی مطالب، حذف و یا افزودن برخی مطالب به نوشته انجام می‌دهد. همچنین به‌منظور انتقال پیام درست به مخاطب اقداماتی از سمت ویراستار انجام می‌شود. از جمله این اقدامات می‌توان به حذف مطالب غیر مستند، بازنگری در نحوه چیدمان کلمات و جملات، ایجاد نظم در مطالب و… اشاره کرد. در ویرایش پایان‌ نامه، معمولاً ویرایش محتوایی و ویرایش تخصصی که قبلاً به آن اشاره شد، به‌صورت هم‌زمان انجام می‌شود.
          </p>
          <p class="mb-4 fw-bold mt-3 me-5">
          3. ویرایش زبانی
          </p>
          <p class="me-5">
          در ویرایش زبانی که به ویرایش ساختاری نیز معروف است، همان‌طور از نامش پیداست، به ساختار متن پرداخته می‌شود. از جمله مواردی که توسط یک ویراستار در ویرایش زبانی بررسی می‌شود، می‌توان به موارد زیر اشاره کرد:
          </p>
          <ul>
          <li>
          بازبینی و تصحیح ساختار جمله
          </li>
          <li>
          حذف کلمات و عبارات زائد
          </li>
          <li>
          انتخاب واژگان مناسب
          </li>
          <li>
          حذف و اصلاح اصلاحات عامیانه
          </li>
          <li>
          کوتاه‌کردن جملات طولانی
          </li>
          <li>
          حذف ابهامات متنی در راستا روان بودن آن
          </li>
          </ul>
          <p class="mb-4 fw-bold mt-3 me-5">
          4. ویرایش فنی
          </p>
          <p class="me-5">
          در ویرایش فنی، ویراستار به اصلاح و بهبود ظاهر متن می‌پردازد و برای انجام این کار به زمان و تمرکز بالایی نیاز دارد. اقداماتی که ویراستار در راستای ویرایش فنی انجام می‌دهد، به شرح زیر است:          </p>
          <ul>
          <li>
          تصحیح غلط‌های املایی
          </li>
          <li>
          بررسی ارتباط جملات با یکدیگر
          </li>
          <li>
          اصلاح علائم نگارشی
          </li>
          <li>
          رعایت قواعد عددنویسی و فرمول‌نویسی
          </li>
          <li>
          بررسی ارجاعات
          </li>
          <li>
          پیاده‌سازی قوانین مربوط به پاورقی
          </li>
          <li>
          بررسی فهرست مطالب
          </li>
          <li>
          بررسی سایز و نوع فونت عناوین، زیر عنوان‌ها، متن اصلی و…
          </li>
          <li>
          بررسی و اصلاح تصاویر، جداول، واژه‌نامه و…
          </li>
          <li>
          اعمال قواعد مربوط به نقل‌قول‌ها
          </li>
          </ul>
          <p class="mb-4 fw-bold mt-3">
          ویرایش پایان‌ نامه در زیراکسی
          </p>
          <p class="mb-5">
          از آن‌جایی که پایان ‌نامه، موضوع مهمی برای دانشجویان در مقاطع مختلف محسوب می‌شود، اکثریت آن‌ها حساسیت زیادی بر روی مفهوم و ساختار محتوای پایان ‌نامه داشته و سعی می‌کنند جنبه‌های علمی آن را رعایت کنند؛ در واقع هر آنچه مربوط به باطن آن است را بادقت و وسواس زیادی انجام می‌دهند.<br />
          آنچه در پایان اهمیت دارد، اصلاح و بهبود ظاهر محتوا یا همان ویرایش فنی است. به دلیل اینکه این مورد به‌صرف زمان و تمرکز بالایی نیاز دارد، دانشجویان ترجیح می‌دهند از افراد متخصص در این زمینه کمک بگیرند.<br />
          زیراکسی در کنار چاپ پایان‌ نامه و صحافی آن، با بهره‌وری از دانش افراد متخصص، ویرایش فنی پایان ‌نامه را با بهترین کیفیت و در کمترین زمان ممکن به کاربران خود ارائه می‌دهد.  
          </p>
          <p class="mb-4 fw-bold mt-3">
          قیمت ویرایش پایان ‌نامه
          </p>
          <p class="mb-5">
          قیمت ویرایش پایان ‌نامه به تعداد کلمات آن وابسته است. در زیراکسی پس از آن که پایان‌نامه توسط کاربر بارگذاری می‌‌شود، توسط ویراستارهای مجرب بررسی می‌شود و هزینه ویراستاری به کاربر اعلام می‌گردد.
          </p>
        `,
    },
  },
};
